angular
  .module('capability-ng-scheduler')
  .service(
    'preferencesCampuses',
    function (
      this: any,
      preferencesSummaryDelegate: any,
      ngPreferencesCampusModel: any,
      ngTimeOccurrenceDataSource: any
    ) {
      this.getSummary = () => {
        const updatedCampuses = ngPreferencesCampusModel.read();
        preferencesSummaryDelegate.setCampusLocation({ campuses: updatedCampuses });
      };
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/services/preferences_campuses.ts